<template>
  <div class="activityqrcode">
    <div class="card">
      <div class="cardName">卡卷信息</div>
      <div class="cardNumAndState clearfix">
        <div class="cardNum">卷码：{{ this.activityqrcode.qrcode }}</div>
        <div class="noUsedStatus" v-if="this.activityqrcode.status == 1">
          未使用
        </div>
        <div class="usedStatus" v-else>已使用</div>
      </div>
      <div class="cardBody clearfix">
        <div class="cardImgDiv">
          <img :src="this.activityqrcode.img" alt="图片" class="cardImg" />
        </div>
        <div class="name">{{ this.activityqrcode.title }}</div>
      </div>
    </div>
    <div class="btnDiv" v-if="this.activityqrcode.status == 1">
      <button class="btn" @click="writeOff">立即核销</button>
    </div>
    <div class="useData" v-if="this.activityqrcode.status == 0">
      <div class="useDataName">使用信息</div>
      <div class="usedDate">核销时间：{{ this.activityqrcode.writeoff_time }}</div>
      <div class="usedPerson">核销人员：{{ this.activityqrcode.operater }}</div>
    </div>
    <div class="tips" v-if="this.activityqrcode.status == 0">该卡卷已使用</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activityqrcode: "",
    };
  },
  created() {
    this.getActivityqrcode();
  },
  methods: {
    async getActivityqrcode() {
      const result = await this.$http({
        url: "/checkwriteoffschoolact",
        method: "POST",
        headers: { "content-type": "application/x-www-form-urlencoded" },
        data: this.$qs.stringify({
          user_id: this.$route.query.user_id,
          school_activity_id: this.$route.query.school_activity_id,
        }),
      });
      this.activityqrcode = result.data.data;
    },
    async writeOff() {
      const result = await this.$http({
        url: "/writeoffschoolact",
        method: "POST",
        headers: { "content-type": "application/x-www-form-urlencoded" },
        data: this.$qs.stringify({
          user_id: this.$route.query.user_id,
          school_activity_id: this.$route.query.school_activity_id,
          openid: window.localStorage.getItem("openid"),
        }),
      });
      if (result.data.subMsg == "OK") {
        this.$toast("核销成功");
        location.reload();
      } else {
        this.$toast(result.data.subMsg);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.activityqrcode {
  position: relative;
  min-height: 100vh;
  .card {
    position: relative;
    left: 5%;
    width: 90%;
    top: 15px;
    background: #ffffff;
    border: 1px solid #e1e1e1;
    border-radius: 15px;
    .cardName {
      margin: 15px 0 15px 15px;
      font-size: 1.3rem;
      font-weight: bold;
      color: #333333;
    }
    .cardNumAndState {
      .cardNum {
        margin: 0 0 15px 15px;
        float: left;
        font-size: 1.1rem;
        font-weight: bold;
        color: #333333;
      }
      .noUsedStatus {
        margin-right: 15px;
        float: right;
        font-size: 1.1rem;
        font-weight: bold;
        color: #00706E;
      }
      .usedStatus {
        margin-right: 15px;
        float: right;
        font-size: 1.1rem;
        font-weight: bold;
        color: #999999;
      }
    }
    .cardBody {
      position: relative;
      .cardImgDiv {
        float: left;
        margin: 15px;
        width: 20%;
        height: 18vw;
        .cardImg {
          width: 100%;
          height: 100%;
        }
      }
      .name {
        position: absolute;
        top: 50%;
        left: 30%;
        transform: translateY(-50%);
        float: left;
        font-size: 1.3rem;
        font-weight: bold;
        color: #333333;
      }
    }
  }
  .useData {
    position: relative;
    left: 5%;
    width: 90%;
    .useDataName {
      margin: 25px 0 15px 15px;
      font-size: 1.3rem;
      font-weight: bold;
      color: #333333;
    }
    .usedDate,
    .usedPerson {
      margin: 0 0 15px 15px;
      float: left;
      font-size: 1.1rem;
      font-weight: bold;
      color: #333333;
    }
  }
  .tips {
    position: absolute;
    bottom: 50%;
    left: 50%;
    transform: translateX(-50%);
  }
  .btnDiv {
    position: absolute;
    bottom: 0%;
    width: 100%;
    .btn {
      width: 100%;
      font-size: 1.1rem;
      background: linear-gradient(270deg, #00706E, #00706E);
      border: none;
      padding: 10px 0;
      color: white;
    }
  }
}
.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.clearfix {
  *zoom: 1;
}
</style>


// WEBPACK FOOTER //
// src/components/writeOff/Activityqrcode.vue